import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class WorkflowStatusModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (WorkflowStatusModel._instance == null) WorkflowStatusModel._instance = new WorkflowStatusModel(authManager);
        return WorkflowStatusModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'core/workflow-statuses');

        this.entityName = 'core.WorkflowStatus';
        this.privileges = {
            create: [["adminWorkflow"]],
            read: [["#everyone"]],
            update: [["adminWorkflow"]],
            delete: [["adminWorkflow"]],
        };

        this.label = 'Workflow State';
        this.setLabel = 'Workflow States';

        this.browser = {
            name: 'default-core-workflowstatus-browser',
            moduleName: 'default-core-workflowstatus-browser',
            moduleTitle: 'Workflow States',
            moduleStateSlotName: 'default-core-workflowstatus-browser',
        };

        this.editor = {
            name: 'default-core-workflowstatus-editor',
            moduleName: 'default-core-workflowstatus-editor',
            moduleTitle: 'Workflow State',
            moduleStateSlotName: 'default-core-workflowstatus-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'workflowId',
                type: 'Workflow',
                persistent: true,
                label: 'Workflow',
            },
            {
                name: 'isInitial',
                type: 'bool',
                persistent: true,
                label: 'Is Start',
            },
            {
                name: 'isFinal',
                type: 'bool',
                persistent: true,
                label: 'Is End',
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
        ];

    }

}
